var map = {
  "./compatibility_check@1x.png": "25031",
  "./compatibility_check@2x.png": "41670",
  "./compatibility_check@3x.png": "66545",
  "./logo_cfm.png": "42027",
  "./logo_gg.png": "12833",
  "./logo_hqv.png": "53038",
  "./logo_ktm.png": "425",
  "./logo_mva.png": "24041",
  "./logo_pmag.png": "4502",
  "./logo_wp.png": "8334"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 73811;
